import { type ReactNode } from "react";

import { type PackagingSelectionVariant } from "~/domains/product/components/PackagingSelection/PackagingSelectionVariant";
import { NewPackagingSelection } from "~/domains/product/components/PackagingSelection/NewPackagingSelection/NewPackagingSelection";
import type { ProductDescriptor } from "~/domains/product/types/ProductDescriptor";

export interface PackagingSelectionProps {
  className?: string;
  selectedCode: string;
  onSelectCode?: (packCode: string) => void;
  product: ProductDescriptor;
  variant?: PackagingSelectionVariant;
  renderExtraInfoOnItem?: (packCode: string) => ReactNode;
  initiallyExpanded?: boolean;
  disabled?: boolean;
  selectionType?: string;
}

export const PackagingSelection = (props: PackagingSelectionProps) => {
  return <NewPackagingSelection {...props} />;
};
